export default {"src":"/_next/static/media/ic_file-plus-line.9061b692.svg","height":24,"width":24};